import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Brand, CenteredCardLayout } from '../../components/layout/CenteredCardLayout';
import { KNOWN_ERROR_CODES, presentError } from '../../lib/errorCatalog';
import { parseErrorCode } from '../../lib/queryParams';
import { track } from '../../lib/logger';

/**
 * Safe error screen (spec §15). Renders only allow-listed, friendly copy keyed
 * by error code; never raw backend messages, stack traces, or PII.
 */
export default function ErrorPage() {
  const [search] = useSearchParams();
  const code = parseErrorCode(search);
  const presentation = presentError(code);
  // Only echo a code we recognise — never reflect an arbitrary value from the URL.
  const knownCode = code && KNOWN_ERROR_CODES.includes(code) ? code : null;

  useEffect(() => {
    track('auth_error_presented', { route: '/error', ...(code ? { errorCode: code } : {}) });
  }, [code]);

  return (
    <CenteredCardLayout>
      <div className="stack">
        <Brand />
        <header>
          <h1>{presentation.title}</h1>
          <p className="muted">
            Vui lòng thử lại. Nếu sự cố tiếp diễn, hãy liên hệ bộ phận hỗ trợ.
          </p>
        </header>
        <Link className="btn btn--primary btn--full" to={presentation.ctaTarget}>
          {presentation.ctaLabel}
        </Link>
        {knownCode ? (
          <details>
            <summary>Thông tin hỗ trợ</summary>
            <p className="muted" style={{ fontSize: '0.85rem' }}>
              Mã lỗi: <code>{knownCode}</code>
            </p>
          </details>
        ) : null}
      </div>
    </CenteredCardLayout>
  );
}
